import type { ChoroplethBreak } from './utils/outageLayerStyles';

/**
 * Swatch list for a class-breaks (choropleth) layer. Built from the same breaks
 * as the ArcGIS renderer so the legend always matches the fills on the map.
 */
export function ChoroplethLegend({
  breaks,
  title = 'Legend',
}: {
  breaks: readonly ChoroplethBreak[];
  title?: string;
}) {
  return (
    <div className="d-grid gap-1">
      <span className="small text-muted">{title}</span>
      <ul className="list-unstyled d-flex flex-column mb-0 gap-1">
        {breaks.map((b) => (
          <li
            key={`${b.min}-${b.max}`}
            className="d-flex align-items-center small gap-2"
          >
            <span
              aria-hidden
              style={{
                display: 'inline-block',
                width: 16,
                height: 12,
                borderRadius: 2,
                backgroundColor: b.color,
                border: '1px solid rgba(90,90,90,0.6)',
                flexShrink: 0,
              }}
            />
            <span>{b.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
